export const environment = {
	production: false,
	wpsEndpoint: 'dev.windowperfect.com',
};
